import React, { ChangeEvent, memo } from "react";
import { useFormContext } from "react-hook-form";
import { clsx } from "clsx";
import Hint from "@/shared/ui/hint";
import { TAttributesRows } from "@/widgets/create-order-form/model/types";
import {
  NewOrderAttributes,
  NewOrderScenario,
  TNewOrderForm,
} from "@/entities/new-order";
import { Checkbox } from "@/shared/ui/checkbox";
import { useAppSelector } from "@/Hooks/redux/useAppSelector";
import { DAYS_ATTRIBUTES } from "../../consts";
import styles from "./attributes-block.module.scss";

export const LaunchAppAttributes = memo(
  ({
    handleCheckboxChange,
    attributesList,
    handleDeleteAttribute,
  }: TAttributesRows) => {
    const { user } = useAppSelector((state) => state.clientDataSlice);
    const { watch } = useFormContext<TNewOrderForm>();

    const scenario = watch("activeScenario");

    const daysListDisabled =
      !attributesList.includes(NewOrderAttributes.Day) ||
      scenario === NewOrderScenario.extend;

    const handleToggleDaysRow = (event: ChangeEvent<HTMLInputElement>) => {
      if (event.target.checked) {
        handleCheckboxChange(event);
      } else if (handleDeleteAttribute) {
        handleDeleteAttribute(NewOrderAttributes.Day);
      }
    };

    return (
      <div className={clsx(styles.row, styles.launch_row)}>
        <div className={styles.row_heading}>
          <div className={styles.heading}>
            <span className={styles.title}>Launch app</span>
            <Hint
              popupText={
                user?.cost_relaunch
                  ? `Select the option if you want your application to run after installation and in the following days. Each launch of the application adds ${user?.cost_relaunch}$ to the installation cost.`
                  : "select the option if you want your application to run after installation and in the following days."
              }
            />
          </div>
          <Checkbox
            name="attributes"
            value="day"
            checked={attributesList.includes(NewOrderAttributes.Day)}
            onChange={handleToggleDaysRow}
            isDisabled={scenario === NewOrderScenario.extend}
          />
        </div>
        <span className={styles.title} data-is-disabled={daysListDisabled}>
          Day
        </span>
        <div className={styles.days_body}>
          <div className={styles.days_row}>
            {DAYS_ATTRIBUTES.slice(0, 7).map((day) => (
              <div className={styles.days_item} key={day.value}>
                <label
                  className={clsx(styles.title, styles.day_title)}
                  data-is-disabled={daysListDisabled}
                  htmlFor={day.value}
                >
                  {day.title}
                </label>
                <Checkbox
                  isDisabled={daysListDisabled}
                  name="days"
                  value={day.value}
                  checked={attributesList.includes(day.value)}
                  onChange={handleCheckboxChange}
                />
              </div>
            ))}
          </div>
          <div className={styles.days_row}>
            {DAYS_ATTRIBUTES.slice(7, 14).map((day) => (
              <div className={styles.days_item} key={day.value}>
                <label
                  className={clsx(styles.title, styles.day_title)}
                  data-is-disabled={daysListDisabled}
                  htmlFor={day.value}
                >
                  {day.title}
                </label>
                <Checkbox
                  isDisabled={daysListDisabled}
                  name="days"
                  value={day.value}
                  checked={attributesList.includes(day.value)}
                  onChange={handleCheckboxChange}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  },
);

LaunchAppAttributes.displayName = "LaunchAppAttributes";
